import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { gt, lt } from 'ember-truth-helpers';
import getNumberSignClass from 'lumen/helpers/get-number-sign-class';

interface MarketTotalRevenueKpiItemReferenceSignature {
  Args: {
    changeValue: number | null;
    formattedChangeValue: string;
    referencePeriod: string;
  };
}

const MarketTotalRevenueKpiItemReference = <template>
  <span
    class="kpi-item__reference text-200--regular flex items-center
      {{getNumberSignClass @changeValue}}"
  >
    {{#if (gt @changeValue 0)}}
      <PrismIcon @color="success" @name="arrow-up" />
    {{else if (lt @changeValue 0)}}
      <PrismIcon @color="critical" @name="arrow-down" />
    {{/if}}
    {{t
      "total_revenue.value.versus.reference_period"
      referencePeriod=@referencePeriod
      value=@formattedChangeValue
    }}
  </span>
</template> satisfies TOC<MarketTotalRevenueKpiItemReferenceSignature>;

export default MarketTotalRevenueKpiItemReference;
